import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import logo from '../components/logo.svg';

const errorMessages: Record<string, string> = {
  csrf_mismatch: 'Security validation failed. Please try again.',
  no_email: 'Could not retrieve your email from Azure AD.',
  auth_failed: 'Authentication failed. Please try again.',
};

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, isAuthenticated, loading } = useAuth();
  const error = searchParams.get('error');

  useEffect(() => {
    if (loading) return;
    if (isAuthenticated) {
      navigate('/');
      return;
    }
    // Auto-redirect to Azure AD if no error (avoid redirect loop on auth failure)
    if (!error) {
      login('/');
    }
  }, [isAuthenticated, loading, navigate, error, login]);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Box component="img" src={logo} alt="Logo" sx={{ height: 48 }} />
          </Box>

          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Cost Calculator
          </Typography>

          {error ? (
            <>
              <Alert severity="error" sx={{ mb: 2 }}>
                {errorMessages[error] || 'An error occurred during sign in.'}
              </Alert>
              <Button
                fullWidth
                variant="contained"
                size="large"
                sx={{ mt: 1 }}
                onClick={() => login('/')}
              >
                Try again
              </Button>
            </>
          ) : (
            <Typography variant="body2" align="center" color="text.secondary">
              Redirecting to sign in...
            </Typography>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
